(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blog-post-related-products"] && !Shopify.designMode) return;
  try {
    class RelatedProductsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.related-products-carousel__track');
      this.prevBtn = this.querySelector('.related-products-carousel__arrow--prev');
      this.nextBtn = this.querySelector('.related-products-carousel__arrow--next');

      this.prevBtn?.addEventListener('click', () => this.scrollByPage(-1));
      this.nextBtn?.addEventListener('click', () => this.scrollByPage(1));
      this.track?.addEventListener('scroll', () => this.updateArrowState());
      window.addEventListener('resize', () => this.updateArrowState());
      this.updateArrowState();
    }

    scrollByPage(direction) {
      if (!this.track) return;
      this.track.scrollBy({ left: this.track.clientWidth * direction, behavior: 'smooth' });
    }

    updateArrowState() {
      if (!this.track) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 1;
      if (this.nextBtn) this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
    }
  }

  if (!customElements.get('related-products-carousel')) {
    customElements.define('related-products-carousel', RelatedProductsCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blog-post-share"] && !Shopify.designMode) return;
  try {
    class BlogPostShare extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.shareUrl;
      const title = this.dataset.shareTitle;

      this.querySelectorAll('[data-share]').forEach((el) => {
        const type = el.dataset.share;

        if (type === 'whatsapp') {
          el.href = `https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`;
          el.target = '_blank';
          el.rel = 'noopener';
        }
        if (type === 'facebook') {
          el.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
          el.target = '_blank';
          el.rel = 'noopener';
        }
        if (type === 'email') {
          el.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`;
        }
        if (type === 'copy') {
          el.addEventListener('click', () => this.copyLink(url, el));
        }
      });
    }

    copyLink(url, el) {
      navigator.clipboard?.writeText(url).then(() => {
        const toast = document.createElement('span');
        toast.className = 'share-copy-message';
        toast.textContent = 'Link copiado';

        el.appendChild(toast);

        requestAnimationFrame(() => {
          toast.classList.add('is-visible');
        });

        setTimeout(() => {
          toast.classList.remove('is-visible');

          toast.addEventListener(
            'transitionend',
            () => toast.remove(),
            { once: true }
          );
        }, 1800);
      });
    }
  }

  if (!customElements.get('blog-post-share')) {
    customElements.define('blog-post-share', BlogPostShare);
  }
  } catch(e) { console.error(e); }
})();

})();
